export var CustomerChatSenderType;
(function (CustomerChatSenderType) {
    CustomerChatSenderType["CUSTOMER"] = "CUSTOMER";
    CustomerChatSenderType["MANAGER"] = "MANAGER";
    CustomerChatSenderType["AI_AGENT"] = "AI_AGENT";
    CustomerChatSenderType["CHANNEL_TALK_BOT"] = "CHANNEL_TALK_BOT";
})(CustomerChatSenderType || (CustomerChatSenderType = {}));
